import { ApiError } from "../api/client";

export function toApiError(error: unknown): ApiError {
  if (error instanceof ApiError) {
    return error;
  }
  return new ApiError({ status: 0, code: "unexpected", message: "Something went wrong. Please try again." });
}

export function fieldMessage(error: ApiError | null | undefined, field: string): string | undefined {
  return error?.details.find((detail) => detail.field === field)?.message;
}
